import {
  Project,
  Button,
  BaseDialog,
  useToast,
  ProjectNew,
} from '@/dc-shared-web/src'
import { useDeleteProject } from '@/dc-shared-web/src/hooks/api/project/useDeleteProject'

export const DeleteProjectDialog = ({
  project,
  onClose,
  onSuccess,
}: {
  project: Project | ProjectNew
  onClose: () => void
  onSuccess: () => void
}) => {
  const { toast } = useToast()

  const { mutate: deleteProject, isLoading } = useDeleteProject({
    onSuccess: () => {
      toast({
        variant: 'success',
        title: `"${project.name}" has been deleted.`,
      })

      onSuccess()
    },
  })

  const onDelete = () => {
    deleteProject({
      projectId: project.uuid || '',
    })
  }

  const onDialogClose = () => {
    /* We avoid closing the dialog if an update is still in progress */
    if (isLoading) return

    onClose()
  }

  return (
    <BaseDialog
      title='Delete project'
      isOpen
      onClose={onDialogClose}
      primaryActionSlot={
        <Button
          onClick={onDelete}
          disabled={isLoading}
          variant='destructive'
          data-testid='delete-project-dashboard-trigger'
        >
          {isLoading ? 'Deleting...' : 'Yes, delete'}
        </Button>
      }
    >
      <p className='tw-text-sm'>
        Are you sure you want to delete &quot;{project.name}&quot;?
      </p>
    </BaseDialog>
  )
}
